import type { TUNDR_ICONS } from '@tundr/theme-assets/tundr-icons/tundr-icons-icons';

export const FontIconSize = {
  Default: 'default',
  Hero: 'hero',
} as const;

export type FontIconSizeType = (typeof FontIconSize)[keyof typeof FontIconSize];

export type FontIconProps = {
  id?: string;
  testId?: string;
  title?: string;
  ariaLabel?: string;
  iconName: TUNDR_ICONS;
  rotation?: 0 | 90 | 180 | 270;
  size?: FontIconSizeType;
};
